import React from "react";
// import '../Menu2.css'; // Updated CSS file
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const TargetAudience = () => {
	return (
		<>
			<Navbar />
			<div>
				<Homecarousel />
			</div>

			<div style={{ padding: "5px", maxWidth: "1330px", margin: "0 auto" }}>
				<div
					className="content-container"
					style={{ marginBottom: "5rem", marginTop: "40px" }}>
					<div className="ta-flex">
						<div
							className="text-container-2"
							style={{
								width: "100%",
								height: "fit-content",
								borderRadius: "0px",
							}}>
							<ul
								style={{
									margin: "0px",
									padding: "0px",
									display: "flex",
									flexDirection: "column",
									gap: "20px",
								}}>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Farmers' Organizations (FPOs and Cooperatives)</b>
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Food Exporters and Agribusinesses</b>
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Agricultural Extension and Advisory Services</b>
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>
												Students and Academic Institutions (Food Supply Chain
												Education)
											</b>
										</span>
									</div>
								</li>
							</ul>
						</div>
						<div
							className="text-container-2"
							style={{
								width: "100%",
								height: "fit-content",
								borderRadius: "0px",
							}}>
							<ul
								style={{
									margin: "0px",
									padding: "0px",
									display: "flex",
									flexDirection: "column",
									gap: "20px",
								}}>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Food Processing Industries</b>
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Quality Assurance and Food Safety Professionals</b>
										</span>
									</div>
								</li>
								<li style={{ margin: "0px" }}>
									<div className="rc-list">
										<div className="rc-icon">
											<svg
												aria-hidden="true"
												className="e-font-icon-svg e-fas-leaf"
												viewBox="0 0 576 512"
												xmlns="http://www.w3.org/2000/svg">
												<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
											</svg>
										</div>
										<span className="koul-text">
											<b>Food Retailers and Supply Chain Entities</b>
										</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default TargetAudience;
